const actions = {
  SET_STATE: 'customerTags/SET_STATE',
  LIST_TAGS: 'customerTags/LIST_TAGS',
  SET_AUDIENCE_STATE: 'customerTags/SET_AUDIENCE_STATE',
  LIST_AUDIENCE: 'customerTags/LIST_AUDIENCE',
}

export default actions
